export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_04.a126b8b8.jpg";